module.exports = __webpack_public_path__ + "static/media/arrow_left_gray.a767c275.svg";